window.addEventListener('DOMContentLoaded', event => {

	const autocompleteModalValue = (modalSort, modalEl) => {
		modalEl.addEventListener('show.bs.modal', () => {
			const inputs = document.getElementsByClassName('form-control');
			let previousValueInput = null;
			let currentValueInput = null;
			[...inputs].forEach(input => {
			if (input.name == modalSort && input.classList.contains('search-field')) {
				previousValueInput = input;
			} else if (input.name === modalSort) {
				currentValueInput = input;
			}
		})
		if (previousValueInput !== null && currentValueInput !== null) {
				currentValueInput.value = previousValueInput.value;
			}
		})
	}

	// Search for modals in the DOM and autofill value from search field.
	const modals = document.getElementsByClassName('modal');
	[...modals].forEach(modal => {
		if (modal.id.includes('-modal')) {
			let modalSort = modal.id;
			modalSort = modalSort.replace('-modal', '');
			autocompleteModalValue(modalSort, modal);
		}
	})
});

async function onClickSaveButton(buttonId, formId, modalId, ajaxFilename, requestArray = [], errorElementId = '') {
	const saveButton = document.getElementById(buttonId);
	if (saveButton) {
		saveButton.disabled = true;
	}
	const form = document.getElementById(formId);

	if (form.checkValidity()) {
		const formData = new FormData(form);
		const formEntries = Object.fromEntries(formData.entries());
		// Make request.
		const { origin } = window.location
		let url = `${origin}/include/ajax/${ajaxFilename}.php`;
		if (requestArray.length) {
			requestArray.forEach((req, i) => url += `${i === 0 ? '?' : '&'}${req.columnName}=${formEntries[req.formName]}`)
		}
		try {

			const response = await fetch(url);
			if (!response.ok) {
				throw new Error(`Response status: ${response.status}`);
			}
			// Close modal.
			const modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(modalId));
			modal.hide();
			if (saveButton) {
				saveButton.disabled = false;
			}

		} catch (error) {
			console.error(error);
			if (errorElementId) {
				const errorElement = document.getElementById(errorElementId);
				if (errorElement) {
					const paragraphEl = document.createElement('p');
					paragraphEl.className = 'modal-error-text';
					paragraphEl.innerText = 'An error occured, check the input form and try again';
					errorElement.appendChild(paragraphEl);
					// Show a general error for 3 seconds.
					setTimeout(() => {
						errorElement.innerHTML = '';
					}, 3000);
				}
			}
			if (saveButton) {
				saveButton.disabled = false;
			}
		}
	} else {
		// Highlight elements that are required.
		[...form.elements].forEach(item => {
			if (!item.checkValidity()) {
				item.classList.add('is-invalid');
			}
		});
		if (saveButton) {
			saveButton.disabled = false;
		}
	}
}
